import { Controller, useFormContext } from 'react-hook-form';
import { TmdxSelect, CustomSelectProps } from '@ds';
import { renderSelectItem } from '@/utils/helpers';

interface ControlledSelectProps extends Omit<CustomSelectProps, 'children'> {
  name: string;
  items: CustomSelectProps['items'];
  children?: CustomSelectProps['children'];
}

export const ControlledSelect = ({ name, items, children = renderSelectItem, ...props }: ControlledSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
        <TmdxSelect
          disallowEmptySelection
          isInvalid={invalid}
          selectedKeys={value ? [value] : []}
          items={items}
          errorMessage={error?.message}
          {...field}
          {...props}
        >
          {children}
        </TmdxSelect>
      )}
    />
  );
};
